import { useState } from 'react'
import { MessageCircle, X } from 'lucide-react'
import { useFranchiseData } from '../hooks/useFranchiseData'
import { API_CONFIG } from '../config/api'

const ChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { franchiseData, loading } = useFranchiseData()

  // Don't render until franchise data is loaded
  if (loading || !franchiseData) {
    return null
  }

  // Build chat URL with dynamic franchise data
  const buildChatUrl = () => {
    const params = new URLSearchParams({
      agency_id: 'starsintransition',
      subdomain: franchiseData.subdomain || 'starsintransition',
      franchise_id: API_CONFIG.FRANCHISE_ID,
      topbar_color: franchiseData.topbar_color || '#FFFFFF',
      button_color: franchiseData.button_color || '#58b8cd',
      main_background_color: franchiseData.main_background_color || '#FFFFFF',
      secondary_background_color: franchiseData.secondary_background_color || '#F5F5F5',
      custom: 'true'
    })
    
    return `https://acms-frontend-agent-embed-prod-1019535049697.europe-west2.run.app?${params.toString()}`
  }

  const chatUrl = buildChatUrl()
  const buttonColor = franchiseData.button_color || '#D98E2B'

  return (
    <>
      {/* Chat Button */}
      {!isOpen && (
        <button
          onClick={() => setIsOpen(true)}
          style={{ backgroundColor: buttonColor }}
          className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 text-white p-3.5 sm:p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-40 flex items-center gap-2 hover:opacity-90"
          aria-label="Open AI Travel Assistant"
        >
          <MessageCircle size={24} />
          <span className="hidden sm:inline font-medium">AI Travel Assistant</span>
        </button>
      )}

      {/* Chat Window */}
      {isOpen && (
        <div className="fixed bottom-3 right-3 left-3 sm:left-auto sm:bottom-6 sm:right-6 z-40">
          <div className="relative">
            {/* Close Button Overlay */}
            <button
              onClick={() => setIsOpen(false)}
              className="absolute -top-2 -right-2 bg-gray-800 text-white hover:bg-gray-700 rounded-full p-1.5 shadow-lg transition-colors z-10"
              aria-label="Close AI Travel Assistant"
            >
              <X size={18} />
            </button>

            {/* Chat Iframe */}
            <iframe
              src={chatUrl}
              className="w-full sm:w-[420px] h-[min(70dvh,560px)] sm:h-[580px] border-0 rounded-lg shadow-2xl"
              title="AI Travel Assistant"
              allow="clipboard-write"
            />
          </div>
        </div>
      )}
    </>
  )
}

export default ChatWidget

